import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
import logFactory from '../../utils/logger';
var log = logFactory('splitio-engine:matcher');
function booleanMatcherContext(ruleAttr
/*: bool */) /*: Function */
{
  return function booleanMatcher(runtimeAttr
  /*: bool */) /*: bool */
  {
    var _context;
    var booleanMatches = ruleAttr === runtimeAttr;
    log.debug(_concatInstanceProperty(_context = "[booleanMatcher] ".concat(ruleAttr, " === ")).call(_context, runtimeAttr));
    return booleanMatches;
  };
}
export default booleanMatcherContext;